import type { UseFormReturn } from 'react-hook-form';
import { useWatch } from 'react-hook-form';
import { Message } from '@gonfalon/messages/Message';
import { msg } from '@gonfalon/messages/msg';
import { FieldGroup, Input, Text, TextField } from '@launchpad-ui/components';

import { MetricUrls } from '../../CreateMetricModal/components/MetricUrls';
import { RequiredLabel } from '../../CreateMetricModal/components/RequiredLabel';
import type { MetricForm } from '../../CreateMetricModal/formUtils';

import { AggregateAsField, MetricDefinitionFormField } from './MetricDefinitionFormField';

import styles from '../../CreateMetricModal/CreateMetricModal.module.css';
interface ClickMetricDetailsProps {
  context: UseFormReturn<MetricForm>;
  /** Measurement window and winsorization, rendered above the definition as for custom metrics. */
  winsorizationAndWindowing?: React.ReactNode;
  /** Renders the sectioned definition band, as decided by `CreateMetricModal`. */
  useSectionedLayout?: boolean;
}

export const ClickMetricDetails: React.FC<ClickMetricDetailsProps> = ({
  context,
  winsorizationAndWindowing,
  useSectionedLayout = false,
}) => {
  const {
    control,
    register,
    formState: { errors },
  } = context;

  const selector = useWatch({ control, name: 'selector', exact: true });
  return (
    <>
      <FieldGroup errorMessage={errors.selector?.message} className={styles.labelInputWrapper}>
        <TextField className={styles.textInput}>
          <RequiredLabel label={msg('metrics.clickTargets.selectorLabel')} htmlFor="selector" />
          <Input
            {...register('selector', { required: msg('metrics.clickTargets.selectorRequired') })}
            placeholder={msg('metrics.clickTargets.selectorPlaceholder')}
            value={selector}
          />
        </TextField>
        <Text slot="subtitle" className={styles.kindHint}>
          <Message id="metrics.clickTargets.selectorHelp" />
        </Text>
      </FieldGroup>
      <MetricUrls context={context} />
      {useSectionedLayout && <AggregateAsField context={context} />}
      {winsorizationAndWindowing}
      <MetricDefinitionFormField
        context={context}
        useSectionedLayout={useSectionedLayout}
        externalAggregationField={useSectionedLayout}
      />
    </>
  );
};
